var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"slo-modal-view"},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.routeModal)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.sloModal)?_c(_vm.params.name,{tag:"component",attrs:{"global":"","params":_vm.params}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }